import { useTranslation } from 'react-i18next';

import { TAB_CONFIG } from '@app/components/HeaderNavigation/constants';
import { useBuildNavigationTabs } from '@app/hooks';

import TabBar from './TabBar';
import { toMobileTabs } from './constants';

const MobileTabBar = (): JSX.Element => {
  const { t } = useTranslation('Nav');
  const navItems = toMobileTabs(useBuildNavigationTabs(TAB_CONFIG), t);

  return <TabBar navItems={navItems} />;
};

export default MobileTabBar;
